<template>
  <app-logo
    class="logo"
    :url="url"
    :logo="logo"
  />
</template>

<script setup>
import AppLogo from '&/atoms/AppLogo'

const { component } = defineProps({
  component: { type: Object, required: true }
})

const { logo_url: logo, link: url = {} } = component.attributes
</script>

<style lang="scss" scoped>
:deep(.logo) {
  max-width: 150px;

  @include mq(sm) {
    max-width: 180px;
  }
}
</style>
